<form [formGroup]="formGroup">
  <div formGroupName="addressSelection">

    <div class="row ">
      <label *ngIf="textPosition === 'end'" class="col-3 mt-2 mogo-label text-end mogo-bold" for="collect-from-input">{{label}}:</label>
      <label *ngIf="textPosition === 'start'" class="col-3 mt-2 mogo-label text-start mogo-bold" for="collect-from-input">{{label}}:</label>

      <div class="col-8" [hidden]="!getCreateMode()?.value">
          <input type="text" class="form-control required" formControlName="addressName" (change)="addressNameAltered()" placeholder="Address Name" />
      </div>
      <div class="col-1" [hidden]="!getCreateMode()?.value">
        <button class="btn btn-link" (click)="toggleCreateMode()" [disabled]="lockdown">
          <ng-icon name="bootstrapSearch" size class="h-100"></ng-icon>
        </button>
      </div>
        <div class="col-8" [hidden]="getCreateMode()?.value">
            <ng-select #masterContactPicker
                class="mb-1 required"
                [items]="masterContacts$ | async"
                [loading]="masterContactsLoading"
                typeToSearchText="Please enter an address"
                [typeahead]="masterContactInput$"
                [compareWith]="compareWith"
                placeholder="Please enter an address"
                bindLabel="masterContactName"
                formControlName="masterContactAddressId">
                <ng-template ng-label-tmp let-item="item">
                  <div class="text-md-start">
                        <strong class="card-title">{{ item.masterContactName }}</strong> - {{item.masterContactAddress}}
                    </div>
                </ng-template>
                <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                    <div class="text-md-start">
                        <strong class="card-title">{{ item.masterContactName }}</strong>
                        <p class="card-subtitle text-muted">{{item.masterContactAddress}}</p>
                    </div>
                </ng-template>
            </ng-select>
        </div>
        <div class="col-1" [hidden]="getCreateMode()?.value">
          <button class="btn btn-link" (click)="toggleCreateMode()" [disabled]="lockdown">
            <ng-icon name="bootstrapPinMapFill" size class="h-100"></ng-icon>
          </button>
        </div>
    </div>

      <div class="row" [hidden]="!getCreateMode()?.value">
          <div class="offset-3 col-8">
            <ng-select #googleAddressPicker
                class="mb-1 required"
                [items]="googleAddresses$ | async"
                [compareWith]="compareWithGoogle"
                [loading]="googleAddressesLoading"
                typeToSearchText="Please enter an address"
                placeholder="Enter a location"
                [minTermLength]="2"
                formControlName="addressDetails"
                bindLabel="description"
                bindValue="description"
                [typeahead]="googleAddressInput$"
                (change)="googleAddressChanged($event)">
                <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                    <div class="text-md-start">
                        <p class="card-title">{{ item.description }}</p>
                    </div>
                </ng-template>
            </ng-select>
        </div>
      </div>
  </div>
  <div *ngIf="showPreciseLocationOptions && addressSelected()">
    <div formGroupName="preciseLocationOptions">
      <div class="row">
      <label class="col-3 mt-2 mogo-label text-start mogo-bold" for="collect-from-input">{{preciseLocationLabel}}:</label>

        <div class="col-7" *ngIf="showPreciseLocationPicker">
            <ng-select #precisLocationOptionPicker
                class="mb-1 required"
                [items]="preciseLocationOptions$ | async"
                typeToSearchText="Select Pickup Location"
                [compareWith]="compareWithDeliveryLocationOverride"
                placeholder="Select Pickup Location"
                bindValue="deliveryLocationOverrideId"
                formControlName="deliveryLocationOverrideId">
                <ng-template ng-label-tmp let-item="item">
                  <div class="text-md-start">
                        {{item.displayName}}
                    </div>
                </ng-template>
                <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                    <div class="text-md-start">
                        <strong class="card-title">{{ item.name }}</strong>
                        <p class="card-subtitle text-muted">{{item.address}}</p>
                    </div>
                </ng-template>
            </ng-select>
        </div>
        <div class="col-2">
          <button class="btn btn-primary" (click)="openCreateNewDeliveryLocationOverrideModal()" [disabled]="lockdown">
            Add Location
          </button>
        </div>
      </div>
    </div>
  </div>
</form>
